import React from 'react';

const AttractionsChart = () => {
  const attractionsData = [
    { name: 'गिरिजा स्थान मंदिर', visitors: 85, importance: 95, color: 'bg-temple-primary' },
    { name: 'पुष्प वाटिका', visitors: 78, importance: 90, color: 'bg-temple-secondary' },
    { name: 'बाग तराग (सरोवर)', visitors: 65, importance: 75, color: 'bg-temple-accent' },
    { name: 'प्रथम मिलन स्थल', visitors: 72, importance: 88, color: 'bg-green-500' },
    { name: 'राम चरणारविंद', visitors: 68, importance: 82, color: 'bg-blue-500' }
  ];

  const developmentProgress = [
    { project: 'मंदिर जीर्णोद्धार', progress: 75, budget: 12 },
    { project: 'सरोवर सौंदर्यीकरण', progress: 45, budget: 8 },
    { project: 'पर्यटन सुविधाएं', progress: 30, budget: 6 },
    { project: 'सड़क विकास', progress: 60, budget: 5 }
  ];

  return (
    <div className="space-y-8">
      {/* Attractions Popularity Chart */}
      <div className="bg-temple-bg-warm rounded-3xl p-6 sm:p-8 shadow-temple border border-temple-primary/10">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-temple-text mb-6 flex items-center">
          <span className="mr-3">📊</span>
          मुख्य आकर्षणों की लोकप्रियता
        </h3>
        <div className="space-y-4">
          {attractionsData.map((attraction, index) => (
            <div key={index} className="bg-temple-bg rounded-2xl p-4 border border-temple-primary/10">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-bold text-temple-text text-sm sm:text-base">{attraction.name}</h4>
                <span className="text-temple-text-muted text-sm">{attraction.visitors}%</span>
              </div>
              <div className="w-full bg-temple-bg-soft rounded-full h-3 mb-2">
                <div 
                  className={`${attraction.color} h-3 rounded-full transition-all duration-1000 ease-out`}
                  style={{ width: `${attraction.visitors}%` }}
                ></div>
              </div>
              <div className="flex justify-between text-xs text-temple-text-muted">
                <span>दर्शनार्थी प्राथमिकता</span>
                <span>धार्मिक महत्व: {attraction.importance}%</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Development Progress Chart */}
      <div className="bg-temple-bg-warm rounded-3xl p-6 sm:p-8 shadow-temple border border-temple-primary/10">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-temple-text mb-6 flex items-center">
          <span className="mr-3">🏗️</span>
          विकास परियोजनाओं की प्रगति
        </h3>
        <div className="space-y-4">
          {developmentProgress.map((project, index) => (
            <div key={index} className="bg-temple-bg rounded-2xl p-4 border border-temple-primary/10">
              <div className="flex justify-between items-center mb-2">
                <h4 className="font-bold text-temple-text text-sm sm:text-base">{project.project}</h4>
                <div className="text-right">
                  <span className="text-temple-primary font-bold text-sm">₹{project.budget} करोड़</span>
                  <div className="text-temple-text-muted text-xs">{project.progress}% पूर्ण</div>
                </div>
              </div>
              <div className="w-full bg-temple-bg-soft rounded-full h-3">
                <div 
                  className="bg-gradient-to-r from-temple-primary to-temple-secondary h-3 rounded-full transition-all duration-1000 ease-out"
                  style={{ width: `${project.progress}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Visitor Statistics */}
      <div className="bg-temple-bg-warm rounded-3xl p-6 sm:p-8 shadow-temple border border-temple-primary/10">
        <h3 className="text-xl sm:text-2xl font-serif font-bold text-temple-text mb-6 flex items-center">
          <span className="mr-3">👥</span>
          वार्षिक दर्शनार्थी आंकड़े
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { period: 'परिक्रमा काल', visitors: '5+ लाख', icon: '🚶‍♂️' },
            { period: 'त्योहारी सीजन', visitors: '2 लाख', icon: '🎉' },
            { period: 'सामान्य दिन', visitors: '500-1000', icon: '📅' },
            { period: 'कुल वार्षिक', visitors: '8+ लाख', icon: '📈' }
          ].map((stat, index) => (
            <div key={index} className="bg-temple-bg rounded-2xl p-4 text-center border border-temple-primary/10">
              <div className="text-2xl mb-2">{stat.icon}</div>
              <h4 className="font-bold text-temple-text text-sm mb-1">{stat.period}</h4>
              <p className="text-temple-primary font-bold text-lg">{stat.visitors}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttractionsChart;